import React from 'react';
import { withTranslation } from 'react-i18next';

import withStyles from '@mui/styles/withStyles';

import _ from 'lodash';
import PropTypes from 'prop-types';

const styles = () => ({
	oops: {
		display: 'block',
		width: '100%',
		border: '1px solid #ccc',
		borderRadius: '4px',
		marginBottom: '20px',
		fontSize: '19px',
		marginTop: '49px',
		textAlign: 'center',
		padding: '25px',
	},
});

class Oops extends React.Component {
	constructor(props) {
		super(props);

		this.try = this.try.bind(this);
	}

	try() {
		let { tryAgain } = this.props;

		if (_.isFunction(tryAgain)) {
			tryAgain();
		}
	}

	render() {
		let { classes, fullName, email, t } = this.props;

		let supportEmail = email ? email : t('HelpEmail');
		let subject = 'Arbitrip for Corporate Request' + (fullName ? 'For ' + fullName : '');
		let mailtoUpdate = encodeURI('mailto:' + supportEmail + '?subject=' + subject);

		return (
			<div className={classes.oops}>
				{t('OopsItLooksLikeSomethingWentWrong')}. {t('Please')}{' '}
				<a href="#!" onClick={this.try}>
					{t('TryAgain')}
				</a>{' '}
				or <a href={mailtoUpdate}>{t('ContactUs')}</a>
			</div>
		);
	}
}

Oops.propTypes = {
	tryAgain: PropTypes.func,
	email: PropTypes.string,
	fullName: PropTypes.string,
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(Oops));
